import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

export const RepliconuserMenuContentPopUp = (props: {
  navigationMetadata: any;
}): ReactElement => {
  return (
    <>
      <Box
        id="userMenuContent"
        className="divDropdownContent userMenuDropdown overthrow divDropdownContentMobile divDropdownContentIPad"
        sx={{
          display: 'block',
          zIndex: '1200',
          width: '242px',
          overflowY: 'auto',
          left: '0px',
          marginBottom: '30px'
        }}
      >
        <div id="userMenuOptions" className="userMenuContent">
          <ul className="divDropdownList" role="presentation">
            {props.navigationMetadata?.settingsButtonMetadata?.groups?.map(
              (setting: any, index: any) => (
                <li role="presentation" key={index}>
                  {index ? (
                    <Divider style={{ margin: '10px' }}></Divider>
                  ) : (
                    <></>
                  )}
                  <a href={setting?.items?.[0]?.href?.toString()}>
                    {setting?.items?.[0]?.displayText}
                    <span className="detail">
                      {setting?.items?.[0]?.detailsText}
                    </span>
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      </Box>
    </>
  );
};
